import React from 'react';
import { Check, ShieldCheck } from 'lucide-react';
import Alt6Layout from '../components/Alt6Layout';
import {
  CtaBand,
  Eyebrow,
  Reveal,
  SectionHead,
} from '../components/Alt6Shared';
import { MIGRATION_STEPS } from '../data/site';

export default function Alt6Switching() {
  return (
    <Alt6Layout title="Switching to Asha">
      <section className="a6-page-hero">
        <div className="a6-container a6-page-hero-inner">
          <Reveal>
            <Eyebrow>Switching</Eyebrow>
          </Reveal>
          <Reveal delay={0.06}>
            <h1>
              Switching PMS is scary. <em>This isn't.</em>
            </h1>
          </Reveal>
          <Reveal delay={0.12}>
            <p>
              Your data comes with you — patients, charts, ledgers, imaging, and
              documents. A dedicated migration lead runs the move, your team gets
              white-glove training, and you go live in about four weeks.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="a6-section">
        <div className="a6-container">
          <SectionHead
            eyebrow="The process"
            title="Five steps, one dedicated lead"
            lede="You keep seeing patients the whole time. We do the heavy lifting."
            centered
          />
          <div className="a6-steps">
            {MIGRATION_STEPS.map((step, i) => (
              <Reveal key={step.step} delay={i * 0.05}>
                <div className="a6-step-row">
                  <span className="a6-step-num">{step.step}</span>
                  <div>
                    <h3>{step.title}</h3>
                    <p>{step.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="a6-section a6-wash">
        <div className="a6-container">
          <div className="a6-grid a6-grid-3">
            {[
              {
                title: 'Nothing left behind',
                body: 'Full historical migration — not a "fresh start" that quietly abandons your ledgers and charts.',
              },
              {
                title: 'Verified before go-live',
                body: 'We reconcile migrated data against your current system, and walk through it with your team until you sign off.',
              },
              {
                title: 'Autopilot ramps gradually',
                body: 'You go live on the platform first. AI takes on more work module by module, at the pace you set.',
              },
            ].map((card, i) => (
              <Reveal key={card.title} delay={i * 0.07}>
                <div className="a6-card">
                  <span className="a6-card-icon">
                    {i === 1 ? (
                      <ShieldCheck size={20} strokeWidth={2.2} />
                    ) : (
                      <Check size={20} strokeWidth={2.4} />
                    )}
                  </span>
                  <h3>{card.title}</h3>
                  <p>{card.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBand
        title="Get a migration plan for your practice."
        body="Tell us what you're running today — we'll map exactly what moves, when, and how."
      />
    </Alt6Layout>
  );
}
